<template>  
  <div class="fotoportada-container" ref="containerRef">

    <!-- Tarjeta centrada -->
    <div class="card-wrap reveal">

      <!-- 🔹 Bloque con fondo -->
      <div class="bloque-principal">

        <!-- Nombrgjhgjasasasdasdasdasdasdasdasdasdasdasdasdasdasdhghgjhges -->
        <div class="names-block reveal">
          <div class="name">{{ firstName }}</div>
          <div class="amp">&</div>
          <div class="name second">{{ secondName }}</div>
        </div>

        <!-- TEXTO -->
      
        <!-- 🔻 Separador gráfico debajo de los nombres -->
        <div class="separator-holder reveal">
          <img :src="require('@/assets/separadorr.png')" alt="Separador" class="separador-img"/>
        </div>

        <!-- Mes -->
        <div class="month reveal">{{ month }}</div>

        <!-- Fila de fecha -->
        <div class="date-strip reveal">

          <div class="side left">
            <span class="chip">{{ weekday }}</span>
            <span class="rule"></span>
          </div>

          <span class="day">{{ day }}</span>

          <div class="side right">
            <span class="rule"></span>
            <span class="chip">{{ time }}</span>
          </div>

        </div>

        <!-- Año -->
        <div class="year reveal"></div>

        <!-- 🔻 separador debajo del lugar -->
        <div class="separator-holder reveal">
          <img :src="require('@/assets/separadorr.png')" alt="Separador" class="separador-img"/>
        </div>

        <!-- TEXTO -->
        <div class="invitacion-valida reveal">
          Invitación válida para:
        </div>

        <!-- ===================== INVITADO / PASES / MESA ===================== -->
        <div
          v-show="(paquete === 2 || paquete === 3 || paquete === 4) && welcomeText"
          class="invite-inline reveal"
        >

          <div class="welcome-text">
            <template v-if="nombresLista.length > 1">
              <div v-for="(n, idx) in nombresLista" :key="idx" class="nombre-item">
                <div>{{ n }}</div>
              </div>
            </template>

            <template v-else>
              {{ welcomeText }}
            </template>
          </div>

          <div class="info-container">

            <div
              v-if="(paquete === 3 || paquete === 4) && numpase"
              class="info-item mini-chip"
            >
              <i class="fas fa-ticket-alt"></i>
              <span>INVITADOS: {{ numpase }}</span>
            </div>

            <div
              v-if="paquete === 4 && mesaText"
              class="info-item mini-chip"
            >
              <i class="fas fa-circle"></i>
              <span>MESA: {{ mesaText }}</span>
            </div>

          </div>

        </div>

      </div>

      <!-- MENSAJE -->
      <div class="mensaje-bienvenida reveal">
        Esta invitación es personal e intransferible,
        no será posible ceder tu lugar a otra persona.
      </div>

    </div>

    <!-- Fondo general -->
    <img :src="require('@/assets/F1.jpg')" alt="Fondo" class="fondo-textura" />

    <!-- 🔻 Flecha -->
    <button
      class="scroll-hint"
      aria-label="Desplázate hacia abajo"
      @click="scrollDown"
    >
      <span class="scroll-text">Desliza</span>
    </button>

  </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue'
import axios from 'axios'
import baseUrl from '../api'

export default {
  name: 'PortadaEstiloMarissa',

  props: {
    firstName:  { type: String, default: 'David' },
    secondName: { type: String, default: 'Judelkis' },
    month:      { type: String, default: 'JULIO' },
    day:        { type: [String, Number], default: 18 },
    year:       { type: [String, Number], default: 2026 },
    weekday:    { type: String, default: 'SÁBADO' },
    time:       { type: String, default: '2026' },
    venue:      { type: String, default: 'VILLA EL GUANO, SANTIAGO DE LOS CABALLEROS ' },
    idInvitado: { type: Number, default: null },
    nombre:     { type: String, default: '' },
    idFestejado:{ type: Number, default: null }
  },

  setup(props){

    const containerRef = ref(null)

    const welcomeText = ref('')
    const mesaText = ref('')
    const numpase = ref(null)
    const paquete = ref(null)

    const fetchData = async () => {

      if(!props.idInvitado) return

      try {

        const url = `${baseUrl}/${props.nombre||''}/${props.idFestejado||''}/${props.idInvitado}`

        const {data} = await axios.get(url)

        welcomeText.value = data.nombre_mostrar
        mesaText.value = data.num_mesa
        numpase.value = data.num_pase
        paquete.value = data.paquete

      } catch(err) {

        console.error(err)

      }
    }

    const scrollDown = () => {

      window.scrollTo({
        top: window.scrollY + window.innerHeight * 0.8,
        behavior: 'smooth'
      })

    }

    onMounted(async()=>{

      await fetchData()

      const observer = new IntersectionObserver((entries)=>{

        entries.forEach((entry)=>{

          if(entry.isIntersecting){

            entry.target.classList.add('visible')

          }

        })

      }, { threshold: 0.15 })

      document.querySelectorAll('.reveal').forEach(el=>{
        observer.observe(el)
      })

    })

    const nombresLista = computed(() =>
      (welcomeText.value || '').split(',').map(s => s.trim()).filter(Boolean)
    )

    return {
      containerRef,
      welcomeText,
      mesaText,
      numpase,
      paquete,
      nombresLista,
      scrollDown
    }
  }
}
</script>

<style scoped>
/* ========= CONTENEDOR ========= */

.fotoportada-container{
  position:relative;
  width:100%;
  min-height:100vh;
  display:flex;
  align-items:flex-start;
  justify-content:center;
  overflow:hidden;
  padding:80px 20px 120px;
  box-sizing:border-box;
}

/* ========= FONDO ========= */

.fondo-textura{
  position:absolute;
  inset:0;
  width:100%;
  height:100%;
  object-fit:cover;
  z-index:0;
}

/* ========= TARJETA ========= */

.card-wrap{
  position:relative;
  z-index:2;
  width:100%;
  margin-top:30px;
  max-width:540px;
}

/* ========= BLOQUE ========= */

.bloque-principal{
  position:relative;
  padding:0;
  display:flex;
  flex-direction:column;
  align-items:center;
}

/* ========= NOMBRES ========= */

.names-block{
  display:flex;
  flex-direction:column;
  align-items:center;
  gap:6px;
  margin:0;
}

.name{
  font-family:'nombres2', serif !important;
  font-size:clamp(50px,8vw,76px);
  color:#b08a5a;
  letter-spacing:.12em;
  font-weight:600;
  line-height:1.1;
  text-align:center;
}

.amp{
  font-family:'padres', serif;
  font-size:clamp(50px,8vw,76px);
  color:#b08a5a;
  line-height:1;
}

/* ========= TEXTO ========= */

.texto-romantico{
  margin-top:22px;
  text-align:center;
  font-family:'Playfair Display', serif;
  font-size:20px;
  line-height:1.9;
  color:#6f6660;
  padding:0 6px;
}

.invitacion-valida{
  margin-top:14px;
  font-family:'Playfair Display', serif;
  font-size:24px;
  color:#a07d52;
  letter-spacing:.06em;
  text-align:center;
}

/* ========= SEPARADOR ========= */

.separator-holder{
  display:flex;
  justify-content:center;
  width:100%;
  margin:22px 0;
}

.separador-img{
  width:80%;
  max-width:320px;
  opacity:.9;
}

/* ========= FECHA ========= */

.month{
  font-family:'Poppins', sans-serif;
  font-size:15px;
  color:#8e867f;
  letter-spacing:.35em;
  text-transform:uppercase;
  margin-bottom:12px;
  text-align:center;
}

.date-strip{
  display:grid;
  grid-template-columns:1fr auto 1fr;
  align-items:center;
  width:100%;
}

.side{
  display:flex;
  align-items:center;
  gap:12px;
}

.left{
  justify-content:flex-end;
  padding-right:14px;
}

.right{
  justify-content:flex-start;
  padding-left:14px;
}

.rule{
  height:1px;
  background:#d9cbb7;
  flex:1;
}

.day{
  font-family:'Playfair Display', serif;
  font-size:clamp(44px,15vw,62px);
  color:#b08a5a;
  line-height:1;
  font-weight:700;
}

.chip{
  font-family:'Poppins', sans-serif;
  font-size:12px;
  color:#8f847c;
  letter-spacing:.2em;
  text-transform:uppercase;
}

.year{
  margin-top:10px;
  font-family:'Playfair Display', serif;
  font-size:24px;
  color:#9b8f86;
  letter-spacing:.35em;
  text-align:center;
}

/* ========= INVITADOS ========= */

.invite-inline{
  margin-top:22px;
  width:100%;
}

.welcome-text{
  font-family:'Playfair Display', serif;
  font-size:30px;
  color:#b08a5a;
  line-height:1.6;
  text-align:center;
}

.nombre-item{
  margin-bottom:6px;
}

.info-container{
  display:flex;
  justify-content:center;
  gap:14px;
  flex-wrap:wrap;
  margin-top:16px;
}

.info-item{
  display:flex;
  align-items:center;
  gap:8px;
  color:#6f6660;
  font-family:'Poppins', sans-serif;
  font-size:13px;
}

.mini-chip{
  border-top:1px solid #d9cbb7;
  border-bottom:1px solid #d9cbb7;
  padding:8px 12px;
}

/* ========= MENSAJE ========= */

.mensaje-bienvenida{
  margin-top:30px;
  text-align:center;
  font-family:'Playfair Display', serif;
  font-size:22px;
  font-weight:700;
  color:#6f6660;
  line-height:1.9;
  padding:0 10px;
}

/* ========= BOTÓN ========= */

.scroll-hint{
  position:fixed;
  right:18px;
  bottom:24px;
  z-index:10;
  border:none;
  background:rgba(255,255,255,.92);
  padding:12px 14px;
  border-radius:999px;
  box-shadow:0 8px 20px rgba(0,0,0,.15);
  cursor:pointer;
  animation:floaty 1.8s ease-in-out infinite;
}

.scroll-text{
  font-family:'Poppins', sans-serif;
  font-size:12px;
  letter-spacing:.15em;
  text-transform:uppercase;
  color:#8e6f49;
}

/* ========= ANIMACIONES ========= */

.reveal{
  opacity:0;
  transform:translateY(45px);
  transition:all 1.2s ease;
}

.reveal.visible{
  opacity:1;
  transform:translateY(0);
}

@keyframes floaty{

  0%{
    transform:translateY(0px);
  }

  50%{
    transform:translateY(-10px);
  }

  100%{
    transform:translateY(0px);
  }

}

/* ========= RESPONSIVE ========= */

@media(max-width:768px){

  .fotoportada-container{
    padding:60px 18px 110px;
  }

  .bloque-principal{
    padding:0;
  }

  .texto-romantico{
    font-size:18px;
    line-height:1.8;
  }

  .welcome-text{
    font-size:24px;
  }

  .mensaje-bienvenida{
    font-size:19px;
    line-height:1.8;
  }

  .date-strip{
    gap:8px;
  }

  .side{
    gap:8px;
  }

}
</style>